import GoogleMaps from "./GoogleMaps";

export default GoogleMaps;
